import funcTranslateHelper from '../../../i18next/funcTranslateHelper';

export const schema = {
  type: 'object',
  properties: {
    name: {
      title: 'name',
      type: 'string',
      placeholder: 'namePlaceholder'
    },
    id: {
      type: 'string'
    },
    logo: {
      title: 'logo',
      type: 'string',
      placeholder: 'logoPlaceholder'
    },
    attributes: {
      type: 'array',
      title: 'attributes',
      items: { $ref: '#/definitions/attribute' }
    }
  },
  definitions: {
    attribute: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
          title: 'attrTitle',
          placeholder: 'attrTitlePlaceholder'
        },
        type: {
          type: 'string',
          title: 'attrType',
          enum: [
            '',
            'string',
            'file',
            'number',
            'boolean',
            'date',
            'array',
            'asset',
            'object',
            'stringArray'
          ],
          enumNames: [
            'chooseOption',
            'text',
            'file',
            'number',
            'bool',
            'date',
            'list',
            'asset',
            'object',
            'stringArray'
          ],
          default: ''
        },
        visualizationRoles: {
          title: 'attrVisualizationRoles',
          $ref: '#/definitions/roles'
        }
      },
      dependencies: {
        type: {
          oneOf: [
            {
              properties: {
                type: {
                  enum: ['', 'string', 'file', 'number', 'boolean', 'date', 'stringArray']
                }
              }
            },
            {
              // array (lista)
              properties: {
                type: {
                  enum: ['array']
                },
                listValue: {
                  type: 'array',
                  title: 'listOptions',
                  placeholder: 'introduceOptions',
                  items: { type: 'string' }
                }
              }
            },
            {
              // object
              properties: {
                type: {
                  enum: ['object']
                },
                objSubtype: {
                  type: 'object',
                  title: '',
                  properties: {
                    objects: {
                      type: 'array',
                      title: 'objects',
                      items: { $ref: '#/definitions/objects' }
                    }
                  },
                  definitions: {
                    objects: {
                      type: 'array',
                      title: 'objects',
                      items: { $ref: '#/definitions/objects' }
                    }
                  }
                }
              }
            },
            {
              // array (asset)
              properties: {
                type: {
                  enum: ['asset']
                },
                assetType: {
                  type: 'string',
                  title: 'assetSelect',
                  enum: [],
                  enumNames: [],
                  default: ''
                }
              }
            }
          ]
        }
      }
    },
    objects: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
          title: 'attrTitle',
          placeholder: 'attrTitlePlaceholder'
        },
        type: {
          type: 'string',
          title: 'attrType',
          enum: [
            '',
            'string',
            'file',
            'number',
            'boolean',
            'date',
            'array',
            'asset',
            'object'
          ],
          enumNames: [
            'chooseOption',
            'text',
            'file',
            'number',
            'bool',
            'date',
            'list',
            'asset',
            'object'
          ],
          default: ''
        },
        visualizationRoles: {
          title: 'attrVisualizationRoles',
          $ref: '#/definitions/roles'
        }
      },
      dependencies: {
        type: {
          oneOf: [
            {
              properties: {
                type: {
                  enum: ['', 'string', 'number', 'file', 'boolean', 'date']
                }
              }
            },
            {
              properties: {
                type: {
                  enum: ['array']
                },
                listValue: {
                  type: 'array',
                  title: 'listOptions',
                  placeholder: 'introduceOptions',
                  items: { type: 'string' }
                }
              }
            }
          ]
        }
      }
    },
    roles: {
      type: 'array',
      minItems: 1,
      items: {
        type: 'string',
        enum: []
      },
      uniqueItems: true
    }
  }
};

export const uiSchema = {
  'ui:rootFieldId': 'form-asset',
  name: {
    'ui:field': 'TextInput',
    classNames: 'form-control-parent'
  },
  logo: {
    'ui:field': 'TextInput'
  },
  id: {
    'ui:field': 'HiddenId'
  },
  attributes: {
    items: {
      title: {
        'ui:field': 'TextInput'
      },
      type: {
        'ui:field': 'Select'
      },
      assetType: {
        'ui:field': 'Select'
      },
      listValue: {
        'ui:field': 'TextInputWithTags'
      },
      date: {
        'ui:field': 'DateInput'
      },
      visualizationRoles: {
        'ui:field': 'MultiSelect'
      },
      'ui:order': [
        'title',
        'type',
        '*',
        'visualizationRoles'
      ],
      objSubtype: {
        classNames: 'row m-0',
        objects: {
          items: {
            title: {
              'ui:field': 'TextInput'
            },
            type: {
              'ui:field': 'Select'
            },
            assetType: {
              'ui:field': 'Select'
            },
            listValue: {
              'ui:field': 'TextInputWithTags'
            },
            visualizationRoles: {
              'ui:field': 'MultiSelect'
            },
            'ui:order': [
              'title',
              'type',
              '*',
              'visualizationRoles'
            ]
          }
        }
      }
    }
  }
};

export const translateSchema = (inputSchema) => {
  function translateProperties (inputProperties) {
    const outputProperties = inputProperties;
    const keys = Object.keys(inputProperties);
    for (let i = 0; i < keys.length; i++) {
      if (inputProperties[keys[i]].title) outputProperties[keys[i]].title = funcTranslateHelper(`Builder:Assets:form:${inputProperties[keys[i]].title}`);
      if (inputProperties[keys[i]].placeholder) outputProperties[keys[i]].placeholder = funcTranslateHelper(`Builder:Assets:form:${inputProperties[keys[i]].placeholder}`);
      if (inputProperties[keys[i]].dependencies) outputProperties[keys[i]].dependencies = translateDependencies(inputProperties[keys[i]].dependencies);
      if (inputProperties[keys[i]].enumNames) {
        outputProperties[keys[i]].enumNames = outputProperties[keys[i]].enumNames.map(element => funcTranslateHelper(`Builder:Assets:form:${element}`));
      }
      if (inputProperties[keys[i]].properties) outputProperties[keys[i]].properties = translateProperties(inputProperties[keys[i]].properties);
    }

    return outputProperties;
  }

  function translateDependencies (inputDependencies) {
    const outputDependencies = inputDependencies;
    if (typeof (inputDependencies.type) === 'object') {
      for (let n = 0; n < inputDependencies.type.oneOf.length; n++) {
        outputDependencies.type.oneOf[n].properties = translateProperties(outputDependencies.type.oneOf[n].properties);
      }
    }

    return outputDependencies;
  }

  function translateDefinition (inputDefinitions) {
    const outputDefinitions = inputDefinitions;
    const definitionsKeys = Object.keys(inputDefinitions);
    for (let i = 0; i < definitionsKeys.length; i++) {
      if (inputDefinitions[definitionsKeys[i]].properties) outputDefinitions[definitionsKeys[i]].properties = translateProperties(outputDefinitions[definitionsKeys[i]].properties);
      if (inputDefinitions[definitionsKeys[i]].dependencies) outputDefinitions[definitionsKeys[i]].dependencies = translateDependencies(outputDefinitions[definitionsKeys[i]].dependencies);
    }
    return outputDefinitions;
  }

  if (inputSchema.properties) inputSchema.properties = translateProperties(inputSchema.properties);
  if (inputSchema.definitions) inputSchema.definitions = translateDefinition(inputSchema.definitions);
};
